var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 17.4605V19.4905C10.7516 21.2105 9.15158 22.6005 7.18158 22.6005C5.21158 22.6005 3.60156 21.2105 3.60156 19.4905V17.4605C3.60156 19.1805 5.20158 20.4005 7.18158 20.4005C9.15158 20.4005 10.7516 19.1705 10.7516 17.4605Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 14.7101C10.7499 15.2101 10.6099 15.6701 10.3699 16.0701C9.77981 17.0401 8.56979 17.6501 7.16979 17.6501C5.76979 17.6501 4.55978 17.0301 3.96978 16.0701C3.72978 15.6701 3.58984 15.2101 3.58984 14.7101C3.58984 13.8501 3.98982 13.0801 4.62982 12.5201C5.27982 11.9501 6.16978 11.6101 7.15978 11.6101C8.14978 11.6101 9.03981 11.9601 9.68981 12.5201C10.3499 13.0701 10.7499 13.8501 10.7499 14.7101Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 14.7101V17.4601C10.7516 19.1801 9.15158 20.4001 7.18158 20.4001C5.21158 20.4001 3.60156 19.1701 3.60156 17.4601V14.7101C3.60156 12.9901 5.20158 11.6001 7.18158 11.6001C8.17158 11.6001 9.06161 11.9501 9.71161 12.5101C10.3516 13.0701 10.7516 13.8501 10.7516 14.7101Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 11.57V13.6301C22.0002 14.1801 21.5602 14.63 21.0002 14.65H19.0401C17.9601 14.65 16.9702 13.86 16.8802 12.78C16.8202 12.15 17.0601 11.56 17.4801 11.15C17.8501 10.77 18.3602 10.55 18.9202 10.55H21.0002C21.5602 10.57 22.0002 11.02 22.0002 11.57Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.1001V9.1001C2 6.3801 3.64 4.4801 6.19 4.1601C6.45 4.1201 6.72 4.1001 7 4.1001H16C16.26 4.1001 16.51 4.11009 16.75 4.15009C19.33 4.45009 21 6.3601 21 9.1001V10.5501H18.92C18.36 10.5501 17.85 10.7701 17.48 11.1501C17.06 11.5601 16.82 12.1501 16.88 12.7801C16.97 13.8601 17.96 14.6501 19.04 14.6501H21V16.1001C21 19.1001 19 21.1001 16 21.1001H13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletActive);
export default __webpack_public_path__ + "static/media/wallet-active.ff5edb938fd8f8680b3a3bd2fcdca55a.svg";
export { ForwardRef as ReactComponent };